import Announcements from "@/components/announcements";
import CustomCursor from "@/components/customCursor";
import Footer from "@/components/footer";
import HeroSection, { AboutSection } from "@/components/heroSection";
import HeroSpacer from "@/components/herospacer";
import IntroScreen from "@/components/IntroScreen";
import FeaturedProject from "@/components/projectSection";
import ScrollProgress from "@/components/scrollProgress";
import V13Styles from "@/components/styles";
import { CurtainReveal } from "@/components/ui/curtainReveal";
import NavBar from "@/components/ui/navbar";
import SEO from "@/components/ui/seo";
import { useState } from "react";

const HomePage = () => {
  const [showIntro, setShowIntro] = useState(
    () => !sessionStorage.getItem("v13-entered")
  );

  return (
    <div className="v13-root min-h-screen">
      <V13Styles />
      <SEO />
      <CurtainReveal />
      <CustomCursor />
      <ScrollProgress />
      <NavBar isHomePage={true} />
      <HeroSection />
      <div className="relative z-10 bg-white">
        <AboutSection />
        {/* Business Verticals hidden per client request — re-enable later if needed */}
        {/* <BusinessSegments /> */}
        <FeaturedProject />
        {/* Subtle announcement marquee — DLF-style, placed above footer */}
        <Announcements />
        <Footer />
      </div>
    </div>
  );
};
export default HomePage